// src/components/RecordAlerts.js
import React, { useState, useEffect } from "react";
import { Alert, Divider, Typography, Spin, Card } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { AlertTwoTone } from "@ant-design/icons"

const { Title } = Typography;

const RecordAlerts = ({ objectName, recordId, alerts }) => {
  const [loading, setLoading] = useState(true);



  return (
    <Card
      title={
        <>
          Alerts <AlertTwoTone />
        </>
      } style={{
        maxWidth: 900,
        borderRadius: 7,
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        marginTop: 0,
        marginBottom: 0
      }}
      bodyStyle={{ padding: 10 }}
    >

      <div
        style={{
          flex: 1, // ✅ take remaining space
          overflowY: "auto",
          backgroundColor: "white",
        }}
      >
        {alerts?.length > 0 ? (
          alerts.map((alert) => (
            <Alert
              key={alert._id}
              message={alert.error_message}
              type={alert.alert_type}
              showIcon
              style={{ marginBottom: 4 }}
            />
          ))
        ) : (
          <p style={{ textAlign: "center", color: "#999" }}>No alerts found</p>
        )}
      </div>

    </Card>
  );
};

export default RecordAlerts;
